
















































































import {Component, Prop, Provide, Vue} from 'vue-property-decorator';
import SelectNodeField from '@c/controls/selectControls/SelectNodeField.vue';
import {PModuleTableHeader, PPingerModule} from '../interfaces';
import PModuleMeasurementEditDialog from '@v/system/modules/forms/PModuleMeasurementEditDialog.vue';
import Table from '@c/tables/Table.vue';
import TableCheckBox from '@c/tables/TableCheckBox.vue';
import SelectDialogField from '@c/controls/selectControls/SelectDialogField.vue';
import {PModuleMeasurementStore} from './pModuleMeasurementStore';
import IconButton from '@c/controls/IconButton.vue';
import CancelChangesDialog from '@c/CancelChangesDialog.vue';
import router from '@/router';
import measurementsStoreModule from '@/store/modules/entities/measurementsModule';
import {updateMeasurements} from '../moduleUtils';
import PModuleButtons from './../../nodes/PModuleButtons.vue';
import nodeModule from '@/store/modules/entities/nodeModule';
import TableDevices from './TableDevices.vue';

@Component({
  components: {
    Table,
    TableCheckBox,
    SelectNodeField,
    PModuleMeasurementEditDialog,
    SelectDialogField,
    IconButton,
    CancelChangesDialog,
    PModuleButtons,
    TableDevices,
  },
})
export default class PingerModuleForm extends Vue {
  loading = false;
  saving = false;

  valid = true;

  nodeName: any = null;

  measurementDialog = PModuleMeasurementEditDialog;

  @Provide()
  @Prop({required: true})
  pmodule!: PPingerModule;

  get measurementsStore() {
    return new PModuleMeasurementStore(this.pmodule);
  }

  measurementsHeaders: PModuleTableHeader[] = [
    {
      text: 'Измерение',
      value: 'measurementDescription',
      sortable: false,
    },
    {
      text: 'В. гр. предупреждения',
      value: 'topWarningBoundary',
      sortable: false,
    },
    {
      text: 'В. гр. опасного значения',
      value: 'topDangerBoundary',
      sortable: false,
    },
    {
      text: 'В. гр. ошибки',
      value: 'topErrorBoundary',
      sortable: false,
    },
  ];

  devicesHeaders: PModuleTableHeader[] = [
    {
      text: 'Наименование',
      value: 'name',
      sortable: false,
    },
    {
      text: 'Ip-адрес',
      value: 'ip',
      sortable: false,
    },
  ];

  nonEmptyTextRule = (v: any) => !!v || (v && v.length === 0) || 'Поле обязательно для заполнения';

  async onSave() {
    this.pmodule.measurements = this.pmodule.measurements.filter((x: any) => x.isActive === true);

    this.valid = await (this.$refs.form as any).validate();

    if (!this.valid) {
      const error = document.querySelector('div.error--text');
      error && this.$vuetify.goTo(error as HTMLElement);
      return;
    }

    this.$emit('save');
  }

  //переменная, сигнализирующая о внесенных и несохраненных изменениях на форме
  changed = false;

  // Действия при изменении поля
  async onChange() {
    this.changed = true;
  }

  async loadMeasurements() {
    // Подгружаем список измерений, ещё не использованных в таблице
    await measurementsStoreModule.fetchAll();
    if (this.pmodule.measurements) {
      const newEntities = measurementsStoreModule.entities.filter(
        (x: any) =>
          x.moduleType === this.pmodule.type &&
          !this.pmodule.measurements.some((y: any) => y.measurementId == x.id),
      );
      // если такие измерения найдены, добавляем их в таблицу измерений модуля
      if (newEntities.length > 0) {
        updateMeasurements(this.pmodule.measurements, newEntities);
      }
    }
  }

  nodeFieldClick() {
    router.push(`/nodes/${this.pmodule.nodes ? this.pmodule.nodes[0].node_id : 0}`); //TODO: fix it?
  }

  updateDevices(jsonString: string) {
    this.pmodule.devices = jsonString;
    this.onChange();
  }

  async created() {
    if (this.pmodule.nodes && this.pmodule.nodes.length > 0) {
      const {data} = await nodeModule.edit(this.pmodule.nodes[0].node_id); //TODO: fix it?
      this.nodeName = data.name;
    }
    //для тех измерений, которые уже сохранены, проставляем isActive = true и isNew = false
    this.pmodule.measurements.forEach((elem: any) => {
      if (!elem.isNew) {
        (elem.isActive = true), (elem.isNew = false);
      }
    });

    await this.loadMeasurements();
  }

  get cancelChangesDialog() {
    return this.$refs.cancelChangesDialog as any;
  }

  back() {
    // если были внесены изменения на форме
    if (this.changed) {
      this.cancelChangesDialog.open('/modules');
    } else router.push('/modules');
  }
}
